// extracted by mini-css-extract-plugin
export default {"cls1":"VeloList-VeloListItem_cls1__goc6I","cls2":"VeloList-VeloListItem_cls2__88ncH VeloList-VeloListItem_cls1__goc6I"};